import { useSelector } from 'react-redux';
import {
  canManageReservations,
  isAdmin,
  isShishaMaster,
  isWaiter,
  resolveStaffRoles,
} from '../utils/staffRoles';

export function useStaffRoles() {
  const auth = useSelector((state) => state.auth);
  const roles = resolveStaffRoles(auth);

  return {
    roles,
    isAdmin: isAdmin(roles),
    isWaiter: isWaiter(roles),
    isShishaMaster: isShishaMaster(roles),
    canManageReservations: canManageReservations(roles),
  };
}
